import React from 'react';

const TopicBlocks = ({ onTopicSelect }) => {
    const exampleTopics = [
        'Economics',
        'Elementary Math',
        'Sociology',
        'Science',
        'Poem Studies',
        'History',
        'Physics',
        'Biology',
        'Literature'
    ];

    return (
        <div className="mt-2 mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">Example topics (click to select):</p>
            <div className="flex flex-wrap gap-2">
                {exampleTopics.map((topic) => (
                    <button
                        key={topic}
                        type='button'

                        onClick={() => onTopicSelect(topic)}
                        className="px-3 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 
                     dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 
                     rounded-md text-sm transition-colors cursor-pointer"
                    >
                        {topic}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TopicBlocks;